import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { BrokerApplication, BrokerApplicationsList } from 'signature-public-api-sdk';

const initialState: BrokerApplicationsList = {
    perPage: 0,
    currentPage: 0,
    totalPages: 0,
    total: 0,
    items: [],
};

const slice = createSlice({
    name: 'applications',
    initialState: initialState,
    reducers: {
        receiveDataSuccess: (
            state,
            {
                payload: { perPage, currentPage, totalPages, total, items },
            }: PayloadAction<{
                perPage: number;
                currentPage: number;
                totalPages: number;
                total?: number | string;
                items: BrokerApplication[];
            }>,
        ) => ({
            ...state,
            perPage: perPage,
            currentPage: currentPage,
            totalPages: totalPages,
            total: total,
            items: [...items],
        }),
        receiveDataFailure: state => ({
            ...state,
            items: [],
        }),
    },
});

export const { name, actions, reducer } = slice;
export const { receiveDataSuccess, receiveDataFailure } = actions;
export default slice;
